import storeInfo from '../store'
import { MaterialsType } from './types'

export const getMaterials = (): MaterialsType => {
  const { materials } = storeInfo.store.getState()
  return materials
}
